<template>
  <div class="login-page">
    <!-- 左侧：品牌视觉区 -->
    <div class="brand-panel">
      <!-- 远山与塔剪影 -->
      <svg class="brand-scene" viewBox="0 0 720 560" width="100%" height="100%" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
        <defs>
          <!-- 塔后暖光：让塔的剪影从深底上立起来 -->
          <radialGradient id="talinGlow" cx="50%" cy="62%" r="56%">
            <stop offset="0%" stop-color="#8c4426" stop-opacity="0.62" />
            <stop offset="46%" stop-color="#50190a" stop-opacity="0.3" />
            <stop offset="100%" stop-color="#2a0b04" stop-opacity="0" />
          </radialGradient>
        </defs>
        <rect x="0" y="0" width="720" height="560" fill="url(#talinGlow)" />
        <!-- 月 -->
        <circle cx="548" cy="128" r="92" fill="#e8d6b4" fill-opacity="0.055" />
        <circle cx="548" cy="128" r="66" fill="#e8d6b4" fill-opacity="0.07" />
        <!-- 远山 -->
        <path d="M0,468 Q150,368 300,436 T580,414 L720,392 L720,560 L0,560 Z" fill="#4b1c0d" fill-opacity="0.45" />
        <path d="M0,512 Q170,412 350,488 T720,462 L720,560 L0,560 Z" fill="#1e0602" fill-opacity="0.92" />
        <!-- 塔 -->
        <g fill="#0a0200">
          <!-- 塔刹 -->
          <circle cx="360" cy="72" r="6" />
          <rect x="357" y="78" width="6" height="34" />
          <rect x="352" y="96" width="16" height="5" />
          <!-- 一层 -->
          <rect x="346" y="118" width="28" height="24" />
          <path d="M330,160 L390,160 L382,142 L338,142 Z" />
          <!-- 二层 -->
          <rect x="340" y="162" width="40" height="26" />
          <path d="M322,204 L398,204 L388,188 L332,188 Z" />
          <!-- 三层 -->
          <rect x="334" y="208" width="52" height="28" />
          <path d="M314,250 L406,250 L394,236 L326,236 Z" />
          <!-- 四层 -->
          <rect x="328" y="256" width="64" height="30" />
          <path d="M306,300 L414,300 L400,286 L320,286 Z" />
          <!-- 五层 -->
          <rect x="322" y="306" width="76" height="32" />
          <path d="M298,352 L422,352 L406,338 L314,338 Z" />
          <!-- 塔基 -->
          <rect x="286" y="354" width="148" height="20" />
          <rect x="270" y="374" width="180" height="12" />
        </g>
        <!-- 前景雾带 -->
        <rect x="0" y="528" width="720" height="32" fill="#100300" fill-opacity="0.95" />
      </svg>

      <!-- 品牌文案 -->
      <div class="brand-content">
        <div class="brand-vertical">
          <span>圣</span><span>山</span><span>塔</span><span>林</span>
        </div>
        <div class="brand-divider"></div>
        <div class="brand-sub">
          <div class="brand-sub-col">
            <span>承</span><span>先</span><span>人</span><span>之</span><span>志</span>
          </div>
          <div class="brand-sub-col">
            <span>续</span><span>家</span><span>族</span><span>之</span><span>脉</span>
          </div>
        </div>
        <div class="brand-seal"><span>塔</span><span>林</span></div>
      </div>
    </div>

    <!-- 右侧：登录表单区 -->
    <div class="form-panel">
      <div class="form-box">
        <div class="form-head">
          <h1 class="form-title">国塔管理系统</h1>
          <p class="form-sub">家族文化数字化运营平台</p>
        </div>

        <el-form
          :model="loginForm"
          :rules="loginRules"
          ref="loginFormRef"
          class="login-form"
          @submit.native.prevent
        >
          <el-form-item prop="username">
            <el-input
              v-model="loginForm.username"
              placeholder="账号"
              prefix-icon="el-icon-user"
              maxlength="20"
            ></el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              placeholder="密码"
              prefix-icon="el-icon-lock"
              type="password"
              show-password
              @keyup.enter.native="handlePasswordLogin"
            ></el-input>
          </el-form-item>

          <el-form-item prop="captcha">
            <div class="captcha-row">
              <el-input
                v-model="loginForm.captcha"
                placeholder="图片验证码"
                prefix-icon="el-icon-picture-outline"
                maxlength="4"
                @keyup.enter.native="handlePasswordLogin"
              ></el-input>
              <div
                class="captcha-box"
                title="点击刷新验证码"
                @click="fetchCaptcha"
              >
                <img v-if="captchaImage" :src="captchaImage" alt="验证码" class="captcha-img" />
                <span v-else class="captcha-tip">点击获取</span>
              </div>
            </div>
          </el-form-item>

          <div class="login-options">
            <el-checkbox v-model="rememberPassword">记住密码</el-checkbox>
            <a href="javascript:void(0)" class="forgot-password" @click="handleForgotPassword">忘记密码？</a>
          </div>

          <el-form-item>
            <el-button
              type="primary"
              @click="handlePasswordLogin"
              class="login-button"
            >登 录</el-button>
          </el-form-item>
        </el-form>

        <div class="login-footer">
          <p>
            <span>版权所有 © 国塔（广西）文化有限公司</span>
            <span class="sep">·</span>
            <span>技术提供 杭州小缘文化科技有限公司</span>
            <span class="sep">·</span>
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">桂ICP备2026021076号-1</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { login, getCaptcha } from "@/api/public.js";
export default {
  name: 'LoginPage',
  data() {
    return {
      // 登录表单
      loginForm: {
        username: '',
        password: '',
        captcha: ''
      },
      // 图片验证码：后端返回的 key（随登录请求带回校验）+ base64 图片
      captchaKey: '',
      captchaImage: '',
      // 登录规则
      loginRules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入图片验证码', trigger: 'blur' }
        ]
      },
      // 记住密码
      rememberPassword: false
    }
  },
  mounted() {
    // 页面加载时，检查是否有记住的密码
    this.loadRememberedPassword()
    // 拉取一张图片验证码
    this.fetchCaptcha()
  },
  methods: {
    // 处理密码登录
    handlePasswordLogin() {
      this.$refs.loginFormRef.validate((valid) => {
        if (valid) {
          // 表单验证通过，执行登录逻辑
          // 使用Vuex的login action处理登录，验证码 key + code 一并带上去
          // 注意：后端校验字段为 captcha_key / captcha_code（表单里的 captcha 即用户输入的验证码）
          this.$store.dispatch('login', {
            username: this.loginForm.username,
            password: this.loginForm.password,
            captcha_key: this.captchaKey,
            captcha_code: this.loginForm.captcha
          }).then(() => {
            // 保存/清除记住的密码
            this.saveRememberedPassword()
            this.$message.success('登录成功')
            // 跳转到首页
            this.$router.push('/home')
          }).catch((error) => {
            // 登录失败：验证码一次性，换一张；清空已输入
            this.loginForm.captcha = ''
            this.fetchCaptcha()
            this.$message.error('登录失败：' + (error.message || '请检查您的登录信息'))
          })
        } else {
          this.$message.error('请填写正确的登录信息')
          return false
        }
      })
    },
    // 获取图片验证码（接口返回 key + base64 图片）
    fetchCaptcha() {
      getCaptcha().then((res) => {
        if (res && res.code === 200 && res.data) {
          this.captchaKey = res.data.key || ''
          this.captchaImage = res.data.image || ''
        }
      }).catch(() => {
        // 接口异常时保留占位，用户可点击手动刷新
        this.captchaImage = ''
      })
    },
    // 加载记住的密码
    loadRememberedPassword() {
      const remembered = localStorage.getItem('rememberedLogin')
      if (remembered) {
        try {
          const loginData = JSON.parse(remembered)
          this.loginForm.username = loginData.username || ''
          this.loginForm.password = loginData.password || ''
          this.rememberPassword = true
        } catch (e) {
          console.error('解析记住的密码失败', e)
        }
      }
    },
    // 保存记住的密码
    saveRememberedPassword() {
      if (this.rememberPassword) {
        const loginData = {
          username: this.loginForm.username,
          password: this.loginForm.password
        }
        localStorage.setItem('rememberedLogin', JSON.stringify(loginData))
      } else {
        localStorage.removeItem('rememberedLogin')
      }
    },
    // 处理忘记密码
    handleForgotPassword() {
      this.$alert('请联系系统管理员重置密码', '忘记密码', {
        confirmButtonText: '知道了',
        type: 'info',
        center: true
      })
    }
  }
}
</script>

<style scoped>
/* ===== 整体布局 ===== */
.login-page {
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: var(--menu-bg);
}

/* ===== 左侧品牌区 ===== */
.brand-panel {
  position: relative;
  flex: 1 1 58%;
  overflow: hidden;
  background: linear-gradient(160deg, #2a0b04 0%, var(--menu-bg) 62%);
}

.brand-scene {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.brand-content {
  position: absolute;
  top: 50%;
  left: 16%;
  transform: translateY(-54%);
  display: flex;
  align-items: flex-start;
}

/* 竖排标题：一列单字（不用 writing-mode），任何内核都不会折行 */
.brand-vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Songti SC', 'STSong', 'SimSun', 'Microsoft YaHei', serif;
  font-size: 64px;
  font-weight: 700;
  line-height: 1;
  color: #ede2cd;
  text-shadow: 0 2px 24px rgba(0, 0, 0, 0.55);
}

.brand-vertical span {
  display: block;
  height: 64px;
  line-height: 64px;
}

.brand-vertical span + span {
  margin-top: 18px;
}

.brand-divider {
  width: 1px;
  align-self: stretch;
  min-height: 220px;
  margin: 0 26px;
  background: linear-gradient(to bottom, rgba(237, 226, 205, 0) 0%, rgba(237, 226, 205, 0.45) 30%, rgba(237, 226, 205, 0.45) 70%, rgba(237, 226, 205, 0) 100%);
}

.brand-sub {
  display: flex;
  align-items: flex-start;
  padding-top: 8px;
}

.brand-sub-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Songti SC', 'STSong', 'SimSun', 'Microsoft YaHei', serif;
  font-size: 16px;
  line-height: 1;
  color: rgba(237, 226, 205, 0.62);
}

.brand-sub-col + .brand-sub-col {
  margin-left: 12px;
}

.brand-sub-col span {
  display: block;
  height: 16px;
  line-height: 16px;
}

.brand-sub-col span + span {
  margin-top: 10px;
}

.brand-seal {
  align-self: flex-end;
  width: 44px;
  height: 78px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #8e1103;
  background-color: var(--primary);
  color: #f5e9d5;
  font-family: 'Songti SC', 'STSong', 'SimSun', serif;
  font-size: 19px;
  font-weight: 700;
  line-height: 1;
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(142, 17, 3, 0.45);
}

.brand-seal span {
  display: block;
}

.brand-seal span + span {
  margin-top: 4px;
}

/* ===== 右侧表单区 ===== */
.form-panel {
  flex: 1 1 42%;
  min-width: 460px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f2e9;
  position: relative;
}

/* 纸面暗纹：右上角淡印 */
.form-panel::before {
  content: '';
  position: absolute;
  top: -120px;
  right: -120px;
  width: 340px;
  height: 340px;
  border: 1px solid rgba(142, 17, 3, 0.08);
  border-radius: 50%;
  pointer-events: none;
}

.form-panel::after {
  content: '';
  position: absolute;
  top: -60px;
  right: -60px;
  width: 340px;
  height: 340px;
  border: 1px solid rgba(142, 17, 3, 0.06);
  border-radius: 50%;
  pointer-events: none;
}

.form-box {
  position: relative;
  width: 360px;
  padding: 0 8px;
}

.form-head {
  margin-bottom: 44px;
  text-align: center;
}

.form-title {
  margin: 0 0 12px;
  font-family: 'Songti SC', 'STSong', 'SimSun', 'Microsoft YaHei', serif;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 6px;
  color: #2c1a10;
}

.form-sub {
  margin: 0;
  font-size: 13px;
  letter-spacing: 3px;
  color: rgba(44, 26, 16, 0.45);
}

/* 标题下的朱红短线 */
.form-head::after {
  content: '';
  display: block;
  width: 32px;
  height: 3px;
  margin: 18px auto 0;
  background: var(--primary);
  border-radius: 2px;
}

/* ===== 表单 ===== */
.login-form >>> .el-input__inner {
  height: 46px;
  line-height: 46px;
  border: 1px solid #ddd2bf;
  background: #fffdf8;
  border-radius: 3px;
  color: #2c1a10;
}

.login-form >>> .el-input__inner:focus {
  border-color: var(--primary);
}

.login-form >>> .el-input__prefix {
  left: 10px;
  color: #a89880;
}

.login-form >>> .el-input__suffix {
  color: #a89880;
}

.login-form >>> .el-checkbox__label {
  font-size: 13px;
  color: rgba(44, 26, 16, 0.6);
}

.login-form >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: var(--primary);
}

.login-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: -4px 0 22px;
}

/* ===== 图片验证码 ===== */
.captcha-row {
  display: flex;
  align-items: stretch;
}

.captcha-row .el-input {
  flex: 1 1 auto;
  min-width: 0;
}

.captcha-box {
  flex: 0 0 120px;
  height: 46px;
  margin-left: 10px;
  border: 1px solid #ddd2bf;
  border-radius: 3px;
  background: #fffdf8;
  cursor: pointer;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  transition: border-color 0.2s;
}

.captcha-box:hover {
  border-color: var(--primary);
}

.captcha-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.captcha-tip {
  font-size: 12px;
  letter-spacing: 1px;
  color: #a89880;
}

.forgot-password {
  font-size: 13px;
  color: rgba(44, 26, 16, 0.5);
  text-decoration: none;
}

.forgot-password:hover {
  color: var(--primary);
}

.login-button {
  width: 100%;
  height: 46px;
  font-size: 16px;
  letter-spacing: 10px;
  text-indent: 10px;
  font-family: 'Songti SC', 'STSong', 'SimSun', 'Microsoft YaHei', serif;
  font-weight: 700;
  background-color: var(--primary);
  border-color: var(--primary);
  border-radius: 3px;
  color: #f5e9d5;
}

.login-button:hover,
.login-button:focus {
  background-color: #a41708;
  border-color: #a41708;
  color: #f5e9d5;
}

/* ===== 底部 ===== */
.login-footer {
  margin-top: 40px;
  text-align: center;
  font-size: 12px;
  letter-spacing: 0.5px;
  color: rgba(44, 26, 16, 0.4);
}

.login-footer p {
  margin: 0;
  line-height: 1.6;
}

.login-footer .sep {
  margin: 0 8px;
  opacity: 0.6;
}

.login-footer a {
  color: rgba(142, 17, 3, 0.8);
  text-decoration: none;
}

.login-footer a:hover {
  text-decoration: underline;
}

/* ===== 响应式 ===== */
@media (max-width: 960px) {
  .brand-panel {
    display: none;
  }

  .form-panel {
    min-width: 100vw;
  }
}
</style>
